export default "__VITE_ASSET__DB5LY1Dx__"